import { useState, useEffect } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import api from '../api/client'
import { useAuth } from '../auth'
import AuthShell, { inputCls, btnCls, btnStyle } from './AuthShell'

export default function RedefinirSenha() {
  const { token } = useParams()
  const nav = useNavigate()
  const { aplicarSessao } = useAuth()
  const [info, setInfo] = useState(null)
  const [estado, setEstado] = useState('carregando')
  const [senha, setSenha] = useState('')
  const [conf, setConf] = useState('')
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let vivo = true
    api.get(`/auth/redefinir-senha/${token}`)
      .then(({ data }) => { if (vivo) { setInfo(data); setEstado('ok') } })
      .catch(() => { if (vivo) setEstado('invalido') })
    return () => { vivo = false }
  }, [token])

  async function submit(e) {
    e.preventDefault()
    setErr('')
    if ((senha || '').length < 6) return setErr('A senha deve ter ao menos 6 caracteres')
    if (senha !== conf) return setErr('As senhas não conferem')
    setLoading(true)
    try {
      const { data } = await api.post(`/auth/redefinir-senha/${token}`, { senha, confirmacao: conf })
      aplicarSessao(data)
      nav('/dashboard')
    } catch (ex) {
      setErr(ex?.response?.data?.detail || 'Não foi possível redefinir a senha')
    } finally { setLoading(false) }
  }

  if (estado === 'carregando') {
    return <AuthShell titulo="Redefinir senha"><p className="text-center text-sm text-gray-500">Validando seu link...</p></AuthShell>
  }
  if (estado === 'invalido') {
    return (
      <AuthShell titulo="Link inválido ou expirado"
        rodape={<Link to="/esqueci-senha" className="font-semibold text-accent-600 hover:underline">Solicitar novo link</Link>}>
        <p className="text-center text-sm text-gray-600">Este link de redefinição não é mais válido. Solicite um novo.</p>
      </AuthShell>
    )
  }

  return (
    <AuthShell titulo="Criar nova senha" subtitulo={info?.email ? `Conta: ${info.email}` : ''}
      rodape={<Link to="/login" className="text-gray-500 hover:underline">Voltar ao login</Link>}>
      {err && <div className="mb-4 p-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm">{err}</div>}
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm font-semibold text-graphite mb-1">Nova senha</label>
          <input type="password" value={senha} onChange={(e) => setSenha(e.target.value)} required className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-semibold text-graphite mb-1">Confirmar senha</label>
          <input type="password" value={conf} onChange={(e) => setConf(e.target.value)} required className={inputCls} />
        </div>
        <button disabled={loading} className={btnCls} style={btnStyle}>
          {loading ? 'Salvando...' : 'Redefinir e entrar'}
        </button>
      </form>
    </AuthShell>
  )
}
